export default __webpack_public_path__ + "static/media/logomini.cea2ac88.png";